<p-dialog modal="true" styleClass="atlas-dialog-l" position="top" [closable]="false" [(visible)]="showCreateEditModal">
  <ng-template pTemplate="header">
    <h4>
      {{
      isEditing
      ? ('events.settings.reminder.dialog-edit-reminder.edit-title' | translate | titlecase)
      : ('events.settings.reminder.dialog-edit-reminder.create-title' | translate | titlecase)
      }}
    </h4>
  </ng-template>
  <form #crudForm="ngForm" class="atlas-form">
    <div class="mct-flex mct-col mct-gap-20" *ngIf="reminder"  >
      <div class="mct-flex mct-row mct-gap-20 mct-fill">
        <div class="mct-basis-50" >
          <label for="daysBeforeEvent" class="form-label">{{
            'events.settings.reminder.dialog-edit-reminder.days-before-the-event' | translate | titlecase
            }}</label>
          <input pInputText name="DaysBeforeEvent" [(ngModel)]="reminder.DaysBeforeEvent"
            (ngModelChange)="onDaysBeforeEventChange($event)" type="number" required class="form-control" />
          <small *ngIf="reminderPast" class="text-danger">
            Reminder would send on {{ reminderDateTimeFormatted }} ({{ eventTimeZone?.Abbreviation || 'local time' }}),
            which is in the past.
          </small>
        </div>
        <div class="mct-basis-50" >
          <label for="sendTime" class="form-label">
            {{ 'events.settings.reminder.dialog-edit-reminder.send-time' | translate | titlecase }} ({{
            eventTimeZone.Abbreviation }})
          </label>
          <wl-time-selector id="sendTime" inputCssClass="form-control" name="SendTime" [(ngModel)]="reminder.SendTime"
            (ngModelChange)="onSendTimeChange($event)" [required]="true">
          </wl-time-selector>
        </div>
      </div>

      <div>
        <label for="subject" class="form-label">{{
          'events.settings.reminder.dialog-edit-reminder.subject' | translate | titlecase
          }}</label>
        <input name="Subject" type="text" [(ngModel)]="reminder.Subject" required class="form-control" />
      </div>

      <div>
        <label for="emailBody" class="form-label">{{
          'events.settings.reminder.dialog-edit-reminder.email-body' | translate | titlecase
          }}</label>
        <div *ngIf="showEditor">
          <wl-modular-wysiwyg-editor #messageMessageField="ngModel" name="emailBody" [editorName]="'emailBody'"
            [(ngModel)]="reminder.EmailBody"
            [emailContent]="true"
            [quickInsertListLabel]="'communications.mass-comm-message-edit.message-edit.special-fields-dropdown-label' | translate"
            [quickInsertList]="specialFields" [showHtmlTemplates]="true" [compact]="true"></wl-modular-wysiwyg-editor>
        </div>
      </div>
    </div>
  </form>

  <ng-template pTemplate="footer">
    <button pButton type="button" class="atlas-btn atlas-btn-secondary mr-10" [disabled]="isSaving" (click)="closeDialog()">
      {{ 'common.cancel' | translate | uppercase }}
    </button>
    <button pButton type="button" class="atlas-btn atlas-btn-primary"
      [disabled]="!crudForm.valid || reminder?.EmailBody === '' || reminderPast" (click)="save()">
      <wl-busy [show]="isSaving"></wl-busy>
      <span [hidden]="isSaving">{{ 'common.save' | translate | uppercase }}</span>
    </button>
  </ng-template>
</p-dialog>
